export type Supplier = { id: string; name: string; rating: number; co2PerUnit: number; pricePerUnit: number };

export function computeOptimalBundle(suppliers: Supplier[], targetUnits = 100): { picks: Array<{supplierId:string; units:number}>; expectedCo2: number; cost: number; complianceGain: number } {
  const sorted = suppliers.slice().sort((a,b)=> (a.co2PerUnit - b.co2PerUnit) || (a.pricePerUnit - b.pricePerUnit));
  let remaining = targetUnits; const picks: Array<{supplierId:string; units:number}> = [];
  for (const s of sorted) { if (remaining<=0) break; const take = Math.min(remaining, Math.ceil(targetUnits/3)); picks.push({ supplierId: s.id, units: take }); remaining -= take; }
  const co2 = picks.reduce((a,p)=> a + (suppliers.find(s=>s.id===p.supplierId)!.co2PerUnit * p.units), 0);
  const cost = picks.reduce((a,p)=> a + (suppliers.find(s=>s.id===p.supplierId)!.pricePerUnit * p.units), 0);
  const avgRating = suppliers.reduce((a,s)=>a+s.rating,0)/Math.max(1,suppliers.length);
  const complianceGain = Math.max(0, (avgRating-50)/2);
  return { picks, expectedCo2: parseFloat(co2.toFixed(2)), cost: parseFloat(cost.toFixed(2)), complianceGain: parseFloat(complianceGain.toFixed(1)) };
}



















